$(document).ready(function () {
  if (typeof meta !== "undefined" && meta.page.pageType == "product") {

    $('input[name="id"]').on('change', function() {
        checkStock();
    });

    function checkStock() {
      
      var product_id = meta.product.id;
      var app_url = "https://phpstack-1328801-4885275.cloudwaysapps.com";
      var variant_id = $('input[name="id"]').val();
      $('.js-product-inventory').hide();
      
      var real_inventory = sessionStorage.getItem('real_inventory_'+variant_id);
      if(real_inventory === null || real_inventory === undefined || real_inventory === '') {
        real_inventory = null;
      }
  
      var stock_alert_time = sessionStorage.getItem('stock_alert_time_'+variant_id);
      if(stock_alert_time === null || stock_alert_time === undefined || stock_alert_time === '') {
        stock_alert_time = null;
      }
      
      $.ajax({
      url: `${app_url}/widget?product_id=${product_id}&variant_id=${variant_id}&real_inventory_${variant_id}=${real_inventory}&stock_alert_time_${variant_id}=${stock_alert_time}`,
      type: "GET",
      success: function (response) {
        if (response.status == "success") {
           $('.js-product-inventory').empty().append(response.html).show();
          
           if(response.fake_inventory <= 3) {

              if(response.reset_time == true) {
                sessionStorage.removeItem('stock_alert_time_'+variant_id);
                sessionStorage.removeItem('real_inventory_'+variant_id);
              } 
              else {
                
                var currentDateTime = new Date().toISOString();
  
                var stock_alert_time = sessionStorage.getItem('stock_alert_time_'+variant_id);
                if(stock_alert_time === null || stock_alert_time === undefined || stock_alert_time === '') {
                  //alert(12, stock_alert_time);
                  console.log('alert time: ' + stock_alert_time);
                  sessionStorage.setItem('stock_alert_time_'+variant_id, currentDateTime);
                }
                
              }
           } 
           else {
             sessionStorage.removeItem('stock_alert_time_'+variant_id);
             if(response.reset_time == true) {
               sessionStorage.removeItem('real_inventory_'+variant_id);
             }  
           }

           var real_inventory = sessionStorage.getItem('real_inventory_'+variant_id);
           if(real_inventory === null || real_inventory === undefined || real_inventory === '') {
             sessionStorage.setItem('real_inventory_'+variant_id, response.real_inventory);
           }
           else {
             if(real_inventory < response.real_inventory) {
               sessionStorage.setItem('real_inventory_'+variant_id, response.real_inventory);
             }
           } 
          
        }
        else {
           $('.js-product-inventory').show();
           sessionStorage.removeItem('stock_alert_time_'+variant_id);
           sessionStorage.removeItem('real_inventory_'+variant_id);
        }
      },
    });
      
    }

    checkStock();
  }
});
